
import { useState } from 'react';

export const useWorkflowPageState = () => {
  const [showSummary, setShowSummary] = useState(false);
  const [selectedReport, setSelectedReport] = useState<{ title: string; content: string } | null>(null);
  const [isGeneratingConsolidated, setIsGeneratingConsolidated] = useState(false);
  const [consolidatedReport, setConsolidatedReport] = useState<string | null>(null);
  const [initializationError, setInitializationError] = useState<string | null>(null);
  const [isInFallbackMode] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);
  const [initializationAttempts, setInitializationAttempts] = useState(0);
  const [shouldStartAnalysis, setShouldStartAnalysis] = useState(false);

  return {
    showSummary,
    setShowSummary,
    selectedReport,
    setSelectedReport,
    isGeneratingConsolidated,
    setIsGeneratingConsolidated,
    consolidatedReport,
    setConsolidatedReport,
    initializationError,
    setInitializationError,
    isInFallbackMode,
    isInitializing,
    setIsInitializing,
    initializationAttempts,
    setInitializationAttempts,
    shouldStartAnalysis,
    setShouldStartAnalysis
  };
};
